var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('the-header',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('app-button',{attrs:{"text":"","to":"/tryout"}},[_vm._v("Add Tryout")])]},proxy:true}])}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }